const mapId = "map-14";
const data = require('./data');
const colors = require('../../../colors');
const L = require('leaflet');
const geoidName = require('../../geoid-placename-crosswalk');

function geoid2name(geoid) {
  if (geoid) {
    let name = geoidName.find(x => x.GEOID == geoid);
    return name ? name.placeName : geoid;
  } else {
    return geoid;
  }
}
// const config = require('../../../config');
//['blue', 'orange', 'teal', 'green', 'lime', 'yellow', 'ochre', 'magenta', 'violet', 'purple']
const colorNames = ['magenta', 'orange', 'blue', 'teal', 'lime', 'green'];

const full = [];
colorNames.forEach(function(name) {
  full.push(colors.secondary[name][100].rgba)
})
const eighty = [];
colorNames.forEach(function(name) {
  eighty.push(colors.secondary[name][80].rgba)
})

full.push("rgba(136,136,136,1)");
eighty.push("rgba(136,136,136,.8)")

let hues = [
  colors.secondary["orange"][100].rgba,
  colors.secondary["orange"][60].rgba,
  colors.secondary["yellow"][100].rgba,
  colors.secondary["blue"][40].rgba,
  colors.secondary["blue"][60].rgba,
  colors.secondary["blue"][100].rgba,
  "rgba(136,136,136,1)"
]

// let borders = hues.map(x => x.replace("1)", ".7)"));

const range = [62, 66.6, 70.9, 75.2, 79.5, 83.8, 88.1]

let mapInstance = L.map(mapId, {
  worldCopyJump: true,
  scrollWheelZoom: false,
})
L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  subdomains: 'abcd',
  maxZoom: 19
}).addTo(mapInstance);

mapInstance.setView([29.94, -90.06], 11, {
  "animate": true,
});

fetch('assets/maps/nola-metro-census-tract.geojson', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
.then(res => res.json())
.then(function(layers) {
  L.geoJson(layers, {
    weight: 1,
    style: function(f) {
      let state = data.find(x => x.geoid == f.properties.GEOID);

      if (state) {
        let hue = "rgba(136,136,136,1)";

        if (state.LE < range[1]) {
          hue = hues[0]
        } else if (state.LE >= range[1] && state.LE < range[2]) {
          hue = hues[1]
        } else if (state.LE >= range[2] && state.LE < range[3]) {
          hue = hues[2]
        } else if (state.LE >= range[3] && state.LE < range[4]) {
          hue = hues[3]
        } else if (state.LE >= range[4] && state.LE < range[5]) {
          hue = hues[4]
        } else if (state.LE >= range[5]) {
          hue = hues[5]
        } else {
          hue = hues[6]
        }

        return {
          "color": "#fff",
          "weight": 1,
          "fillColor": hue,
          "fillOpacity": .8,
          "opacity": 1
        };
      } else {
        return {
          "color": "#fff",
          "weight": 1,
          "fillColor": "#888",
          "fillOpacity": .8,
          "opacity": 1
        };
      }
    },
    onEachFeature: function(f, l) {
      let name = geoid2name(f.properties.GEOID)+'<br />'+f.properties.NAMELSAD;
      let state = data.find(x => x.geoid == f.properties.GEOID)
      if (state) {
        name += "<br />Life Expectancy: " + state.LE + ' years';
      } else {
        name += "<br />No data"
      }
      l.bindTooltip(name, {
        closeButton: false
      });
    }
  }).addTo(mapInstance);
});